import CheckIcon from '@mui/icons-material/Check'
import { Box, Chip, ChipProps } from '@mui/material'
import { RfqStatus } from '../gql/schema-types'
type Props = {
  status: RfqStatus
  dateClosed?: Date
} & ChipProps
export default function RfqStatusChip(props: Props) {
  const { status, dateClosed, ...passedProps } = props
  const commonProps: ChipProps = {
    ...passedProps,
    sx: {
      cursor: 'default',
      '& abbr': {
        fontWeight: 'bold',
        textDecoration: 'none',
      },
    },
  }
  switch (status) {
    case RfqStatus.New:
      return <Chip label={status} color="info" title="This RFQ has not yet been quoted." {...commonProps} />
    case RfqStatus.PaidInFull:
      return (
        <Chip
          avatar={
            <Box color="white" component="span" lineHeight={0} maxHeight={1}>
              <CheckIcon fontSize="small" sx={{ color: 'white' }} />
            </Box>
          }
          label={<abbr title="Paid in Full">PIF</abbr>}
          color="success"
          title="This RFQ has been paid in full."
          {...commonProps}
        />
      )
    case RfqStatus.Paid:
      return <Chip label={status} color="success" title="This RFQ has been paid." {...commonProps} />

    case RfqStatus.Purchased:
      return <Chip label={status} color="warning" title="This RFQ is open for quoting." {...commonProps} />
    case RfqStatus.Closed:
      return (
        <Chip
          label={status}
          color="default"
          title={dateClosed ? `This RFQ was closed ${dateClosed.toLocaleDateString()}` : 'This RFQ was closed.'}
          {...commonProps}
        />
      )
    case RfqStatus.Quoted:
      return <Chip label={status} color="warning" title="This RFQ has been quoted." {...commonProps} />
  }
  return <Chip label={status} color="info" title="This RFQ has not yet been quoted." {...commonProps} />
}
